import React from "react";
import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import getCookie, { setStudentCookie, studentState } from "../../Atom";
import Snackbar from "@mui/material/Snackbar";
import { Link, useParams } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Paper from "@mui/material/Paper";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import Sign_in_image from "../../../teacher-admin-builds/assets/images/Sign_in_image.jpg";
import { getAssignedLaunchForStudent } from "./api";
import { Tooltip } from "@mui/material";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "File Name",
  },
  {
    id: "originalName",
    numeric: false,
    disablePadding: true,
    label: "Original Name",
  },
  {
    id: "pressure",
    numeric: true,
    disablePadding: true,
    label: "Pressure",
  },
  {
    id: "volumeOfWater",
    numeric: true,
    disablePadding: true,
    label: "VOW",
  },
  {
    id: "volumeOfEngine",
    numeric: true,
    disablePadding: true,
    label: "VOE",
  },
  {
    id: "nozzleSize",
    numeric: false,
    disablePadding: true,
    label: "Nozzie Size",
  },

  {
    id: "rocketDryMass",
    numeric: true,
    disablePadding: true,
    label: "RDM",
  },
  {
    id: "parachuteSize",
    numeric: true,
    disablePadding: true,
    label: "Parachute Size",
  },
  // {
  //   id: 'Analyze',
  //   numeric: true,
  //   disablePadding: true,
  //   label: 'Analyze',
  // },
  // {
  //   id: 'Action',
  //   numeric: true,
  //   disablePadding: true,
  //   label: 'Action',
  // },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const [iconShow, setIconShow] = useState(true);

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            //  sx={{background:'none'}}
            align={"center"}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ backgroundColor: "transparent", marginX: "1px" }}
          >
            <Tooltip title={headCell?.label==="VOW"?"Volume of Water":headCell?.label==="VOE"?"Volume of Engine":headCell?.label==='RDM'?'Rocket Dry Mass':headCell?.label } placement="top">
            <TableSortLabel
              className="sort-header btn-wh2"
              sx={{
                display: "flex",
                justifyContent: "center",
                minHeight: "40px",
                display: "flex",
                color: "#000000",
                fontWeight: 500,
                fontSize: 14,
                lineHeight: "16.94px",
                fontFamily: "Inter",
              }}
              active={orderBy === headCell.id && !iconShow}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              // hideSortIcon={iconShow}
              onMouseEnter={() => setIconShow(false)}
              onMouseLeave={() => setIconShow(true)}
            >
              <div className="text-Center fonted fontAdjust-700">
                {headCell.label}
              </div>
            </TableSortLabel>
            </Tooltip>
          </TableCell>
        ))}

        <TableCell
          align={"center"}
          sx={{
            color: "#000000",
            fontWeight: 500,
            fontSize: 14,
            fontFamily: "Inter",
            backgroundColor: "transparent",
          }}
          padding={"normal"}
        >
          <div className="text-Center fonted fontAdjust-700 sort-header btn-wh2">View</div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    //
    <div className="pt-10"></div>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
export default function Launchtrak(props) {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const history = useHistory();
  const [serial, setSerial] = useState(null);
  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [myUser, setmyUser] = useState(studentState);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("createdAt");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageLimit, setPageLimit] = useState(25);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(pageLimit);
  const [launchtrak, setLaunchtrak] = React.useState([]);
  const [currPage, setCurrPage] = useState(0);
  const [noOfPages, setNoOfPages] = useState(0);
  const [paged, setPaged] = useState(0)
   
  const onSetOrder=(event,property)=>{
    let orderTemp=order==='asc'?'desc':'asc';
    let urlPage = parseInt(params.get('page')) || 0;
    let urlLimit = parseInt(params.get('limit')) || pageLimit;
    let urlSerial = params.get('serial')
      history.replace({
        pathname: '/launchtrak',
        search: `?${(urlSerial) ? `serial=${urlSerial}&` : ''}` + 'page=' + urlPage + '&limit=' + urlLimit +'&orderBy='+property +'&order='+orderTemp
      })
      getListOflaunchtrak(urlPage, urlLimit,property,orderTemp,myUser,true);
    setOrder(orderTemp);
    setOrderBy(property);
  }
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = launchtrak.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const handleChangePage = (event, newPage) => {
    setPaged(newPage);
    ////console.logpaged)

    getListOflaunchtrak(event.selected, pageLimit);
    history.replace({
      pathname: "/launchtrak",
      search:
        `?${serial ? `serial=${serial}&` : ""}` +
        "page=" +
        event.selected +
        "&limit=" +
        pageLimit,
    });
  };
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - launchtrak.length) : 0;
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })

      setStudentCookie({
        fName: null,
        userId: null,
        token: null,
        lName: null,
      });

      let hostname = window.location.host;
      window.location.assign(`${window.location.protocol}//${hostname}/`);
    });
  };

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };

  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  const getListOflaunchtrak = async (pages, limits,orderBy,order, user = myUser,orderFlag) => {
    let arr = [];
    setLaunchtrak([]);
    let res;
    res = await getAssignedLaunchForStudent(
      user?.token,
      pages,
      limits,
      orderBy,order,
      user?.userId
    );
    if (res?.error) {
      if (res?.data?.status == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      setLaunchtrak(res?.res?.data?.lan);
      let divisor = parseInt(res?.res?.data?.totalCount / limits);
      let remainder = res?.res?.data?.totalCount % limits == 0 ? 0 : 1;
      setNoOfPages(divisor + remainder);
      setCurrPage(pages);
    }
  };

  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["student"];
      setmyUser(user);
      props.page("launchtrak");
      let urlPage = parseInt(params.get('page')) || 0;
      let urlLimit = parseInt(params.get('limit')) || pageLimit;
      let urlOrderBy = params.get('orderBy') || 'createdAt';
      let urlOrder = params.get('order') || 'desc';
      let urlSerial = params.get('serial')
      if (parseInt(params.get('page')) || parseInt(params.get('limit'))) {
        history.push({
          pathname: '/launchtrak',
          search: `?${(urlSerial) ? `serial=${urlSerial}&` : ''}` + 'page=' + urlPage + '&limit=' + urlLimit +'&orderBy='+urlOrderBy +'&order='+urlOrder
        })
        getListOflaunchtrak(urlPage, urlLimit,urlOrderBy,urlOrder,user);
        setPaged(urlPage);
        setSerial(urlSerial);
        setPageLimit(urlLimit);
      } else {
        history.replace({
          pathname: '/launchtrak',
          search: `?${(urlSerial) ? `serial=${urlSerial}&` : ''}` + `page=0&limit=25&orderBy=${orderBy}&order=${order}`
        })
        getListOflaunchtrak(0, pageLimit,orderBy,order,user)
      }
    }
  }, []);

  return (
    <main style={{ position: "absolute", width: "100%", top: "20%" }}>
      <div className="container px-4 pt-3">
        <div className="upper-section px-60">
          <div className="breadcrumb-menu py-2">
            <a className="disable">Students Panel </a>
            <i className="fas fa-angle-double-right"></i>
            <a className="disable">LaunchTrak Files</a>
          </div>
          <div className="text-blue maintext">
            <h2 className="h2">LaunchTrak Files</h2>
          </div>
          <div className="">
            <div className="">
              <div className="card-header px-0">
                <h3 className="h3">
                  Manage and analyze LaunchTrak Files here
                </h3>
              </div>
            </div>
          </div>
          {/* <br/> */}
          <div className="d-flex justify-content-end align-items-end">
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={noOfPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handleChangePage}
              containerClassName="pagination"
              activeClassName="activePage active"
              forcePage={currPage}
            />
          </div>
        </div>
        <div className=" px-3">
          <div className="row table-section launchtrak ">
            <div className="lower-section px-4 pt-3 w-100">
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    mb: 2,
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  }}
                >
                  <EnhancedTableToolbar numSelected={selected.length} />
                  <TableContainer>
                    <Table
                      sx={{ minWidth: 750, backgroundColor: "transparent" }}
                      aria-labelledby="tableTitle"
                      size={"small"}
                      stickyHeader
                    >
                      <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={onSetOrder}
                        rowCount={launchtrak.length}
                      />
                      <TableBody
                        sx={{
                          backgroundColor: "transparent",
                          color: "#1A273B",
                        }}
                        className="table-body fonted"
                      >
                        {launchtrak
                          .map((launchtrak, index) => {
                            const isItemSelected = isSelected(launchtrak.name);
                            const labelId = `enhanced-table-checkbox-${index}`;

                            return (
                              <TableRow
                                hover
                                // onClick={(event) => handleClick(event, launchtrak.name)}
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={launchtrak.name}
                                selected={isItemSelected}
                                sx={{
                                  backgroundColor: "transparent",
                                  fontFamily: "Exo2-Regular",
                                }}
                                className="fonted"
                              >
                                {/* <TableCell align="right" className="fitted" sx={{fontFamily:'Exo2-Regular',fontSize:'medium'}}>{index+1}</TableCell> */}

                                {/* <TableCell align="center" style={{width:'20px'}} className="fitted" sx={{fontFamily:'Exo2-Regular',fontSize:'medium'}}><div className='d-flex justify-content-center'>{index+1}</div></TableCell> */}
                                <TableCell
                                  className="fitted experimental-td"
                                  style={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#000000",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    fontFamily: "Inter",
                                    lineHeight:'16.96px'
                                  }}
                                >
                                  {launchtrak?.name}
                                </TableCell>
                                <TableCell
                                  className="fitted experimental-td"
                                  style={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#000000",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    fontFamily: "Inter",
                                    lineHeight:'16.96px'
                                  }}
                                >
                                  {launchtrak?.originalName}
                                </TableCell>
                                <TableCell
                                  className="fitted experimental-td"
                                   style={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#000000",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    fontFamily: "Inter",
                                    lineHeight:'16.96px'
                                  }}
                                >
                                  {launchtrak?.pressure
                                    ? launchtrak?.pressure?.toFixed(2) +
                                      " " +
                                      "psi"
                                    : "--"}
                                </TableCell>
                                <TableCell
                                  className="fitted"
                                  align="center"
                                   style={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#000000",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    fontFamily: "Inter",
                                    lineHeight:'16.96px'
                                  }}
                                >
                                  {launchtrak?.volumeOfWater
                                    ? launchtrak?.volumeOfWater?.toFixed(2) +
                                      " " +
                                      "ml"
                                    : "--"}
                                </TableCell>

                                <TableCell
                                  className="fitted"
                                  align="center"
                                   style={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#000000",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    fontFamily: "Inter",
                                    lineHeight:'16.96px'
                                  }}
                                >
                                  {launchtrak?.volumeOfEngine
                                    ? launchtrak?.volumeOfEngine?.toFixed(2) +
                                      " " +
                                      "ml"
                                    : "--"}{" "}
                                </TableCell>

                                <TableCell
                                  className="fitted"
                                  align="center"
                                   style={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#000000",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    fontFamily: "Inter",
                                    lineHeight:'16.96px'
                                  }}
                                >
                                  {launchtrak?.nozzleSize
                                    ? launchtrak?.nozzleSize?.toFixed(2) +
                                      " " +
                                      "mm"
                                    : "--"}{" "}
                                </TableCell>
                                <TableCell
                                  className="fitted"
                                  align="center"
                                   style={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#000000",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    fontFamily: "Inter",
                                    lineHeight:'16.96px'
                                  }}
                                >
                                  {launchtrak?.rocketDryMass
                                    ? launchtrak?.rocketDryMass?.toFixed(2) +
                                      " " +
                                      "g"
                                    : "--"}{" "}
                                </TableCell>
                                <TableCell
                                  className="fitted"
                                  align="center"
                                   style={{
                                    fontFamily: "Exo2-Regular",
                                    fontSize: "medium",
                                    color: "#000000",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    fontFamily: "Inter",
                                    lineHeight:'16.96px'
                                  }}
                                >
                                  {launchtrak?.parachuteSize
                                    ? launchtrak?.parachuteSize?.toFixed(2) +
                                      " " +
                                      "m²"
                                    : "--"}
                                </TableCell>

                                <TableCell
                                  className="fitted"
                                >
                                  <div className="d-flex class-btn justify-content-center">
                                    <div className="btn-wh1 text-center d-flex align-items-center py-0">
                                      <div className="pt-1 pb-0 d-flex align-items-center p-2">
                                        <Link
                                          to={{
                                            pathname: `/launchtrak/${launchtrak?._id}`,
                                            state: {
                                              id: launchtrak?._id,
                                              fileName:launchtrak?.originalName ||  launchtrak?.name,
                                            },
                                          }}
                                          style={{
                                            fontFamily: "Exo2-Regular",
                                            fontSize: "medium",
                                            color: "#000000",
                                            fontWeight: 500,
                                            fontSize: 14,
                                            fontFamily: "Inter",
                                            lineHeight:'16.96px'
                                          }}
                                        >
                                          View
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        {emptyRows > 0 && (
                          <TableRow
                            style={{
                              height: (dense ? 33 : 53) * emptyRows,
                            }}
                          >
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Box>
              <Snackbar
                open={snackBarShow}
                autoHideDuration={3000}
                onClose={SnackClose}
              >
                <Alert
                  onClose={SnackClose}
                  severity={snackBarSeverity}
                  sx={{ width: "100%" }}
                >
                  {snackBarMessage}
                </Alert>
              </Snackbar>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
